import React, { Component } from 'react';


class AdPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };
  }

  componentDidMount() {
    // Show popup after 5 seconds
    this.showTimer = setTimeout(() => {
      this.setState({ showPopup: true });

      // Auto-close after 10 seconds
      this.closeTimer = setTimeout(() => {
        this.setState({ showPopup: false });
      }, 10000);
    }, 5000);
  }

  componentWillUnmount() {
    clearTimeout(this.showTimer);
    clearTimeout(this.closeTimer);
  }

  closePopup = () => {
    this.setState({ showPopup: false });
    clearTimeout(this.closeTimer); // Prevent auto-close after manual close
  };

  render() {
    const { showPopup } = this.state;

    return (
      <>
        {showPopup && (
          <div className="ad-popup">
            <div className="ad-content">
              <h2>🩺 Free Health Checkup Camp!</h2>
              <p>Join us this weekend at KlinicQ for free consultations and diagnostics.</p>
              <button onClick={this.closePopup}>Close</button>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default AdPopUp;
